import BigDecimal from 'js-big-decimal'
import DataType from '@/util/dataType'
import { SystemEnum } from '@/assets/js'
import store from '@/store/index'
class Tool {
  turnTo (router, page) {
    router.push(page)
  }

  getEnumTextByValue (e, value) {
    let text = ''

    for (const item in e) {
      // eslint-disable-next-line eqeqeq
      if (e[item].value == value) {
        text = e[item].text
      }
    }

    return text
  }

  getEnumByValue (e, value) {
    for (const item in e) {
      // eslint-disable-next-line eqeqeq
      if (e[item].value == value) {
        return e[item]
      }
    }

    return null
  }

  IBVData (key, value) {
    if (key === DataType.JsonKeyConst.REQUEST_CODE) {
      return value
    } else if (key === DataType.JsonKeyConst.CONTACT_TYPE) {
      if (parseInt(value) === 0) {
        return `${DataType.IBVSelectContactType.SEND_BY_EMAIL.text}`
      } else {
        return `${DataType.IBVSelectContactType.SEND_BY_SMS.text}`
      }
    }
  }

  isNull (value) {
    return value === undefined || value === null
  }

  isNotNull (value) {
    return value !== undefined && value !== null
  }

  isNotUndefined (value) {
    return value !== undefined
  }

  isNotEmpty (value) {
    return (
      value !== undefined &&
      value !== '' &&
      value !== null &&
      value !== 'N/A' &&
      JSON.stringify(value) !== '{}' &&
      JSON.stringify(value) !== '[]'
    )
  }

  isEmpty (value) {
    return (
      value === undefined ||
      value === null ||
      value === 'N/A' ||
      value === '' ||
      JSON.stringify(value) === '{}' ||
      JSON.stringify(value) === '[]'
    )
  }

  formatCurrencyWithFieldKey (data, fieldKey) {
    if (this.isEmpty(data) || this.isEmpty(fieldKey) || this.isEmpty(data[fieldKey])) {
      return '$0.00'
    } else {
      return this.formatCurrency(data[fieldKey])
    }
  }

  formatCurrency (num) {
    if (this.isNotEmpty(num)) {
      if (Number(num) === 0) {
        return '$0.00'
      }
      if (num) {
        num = Number(num).toFixed(2)
        // 将num中的$,去掉，将num变成一个纯粹的数据格式字符串
        // eslint-disable-next-line no-useless-escape
        num = num.toString().replace(/\$|\,/g, '')
        // 如果num不是数字，则将num置0，并返回
        if (num === '' || isNaN(num)) {
          return 'Not a Number ! '
        }
        // 如果num是负数，则获取她的符号
        const sign = num.indexOf('-') > -1 ? '-' : ''
        let cents = num.indexOf('.') > -1 ? num.substr(num.indexOf('.')) : '.00'
        for (let i = 0; i < 3 - cents.length; ++i) {
          cents = cents + '0'
        }

        let numStart = 0
        if (sign === '-') {
          numStart = 1
        }
        num = num.indexOf('.') > -1 ? num.substring(numStart, num.indexOf('.')) : num.substr(numStart)
        /*
          也可以这样想象，现在有一串数字字符串在你面前，如果让你给他家千分位的逗号的话，你是怎么来思考和操作的?
          字符串长度为0/1/2/3时都不用添加
          字符串长度大于3的时候，从右往左数，有三位字符就加一个逗号，然后继续往前数，直到不到往前数少于三位字符为止
         */
        for (let i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
          num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3))
        }

        if (num.length > 0 && num.substr(0, 1) === ',') {
          num.slice(0)
        }

        // 将数据（符号、整数部分、小数部分）整体组合返回
        if (sign === '-') {
          return '($' + num + cents + ')'
        } else {
          return '$' + num + cents
        }
      }
    } else {
      return ''
    }
  }

  formatDateWithZero (timestamp) {
    if (timestamp === 0 || timestamp === '0') {
      return 'N/A'
    } else {
      return this.formatDate(timestamp)
    }
  }

  formatDate (timestamp) {
    let result = null
    try {
      if (this.isNotEmpty(timestamp)) {
        if (/[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}/.test(timestamp.toString())) {
          return timestamp
        }
        if (typeof timestamp === 'string') {
          timestamp = parseInt(timestamp, 10)
        }

        if (this.isNotEmpty(timestamp)) {
          const timeZone = this.isSummerTime(timestamp)
          const offset = (new Date(timestamp).getTimezoneOffset() / 60 + timeZone) * 3600 * 1000
          if (typeof offset === 'number') {
            timestamp += offset
            result = new Date(timestamp).format('yyyy-MM-dd')
          } else {
            const time = new Date(timestamp)
            const year = time.getUTCFullYear()
            const month = time.getUTCMonth() + 1
            const day = time.getUTCDate()

            result = year + '-'

            if (month < 10) {
              result += '0' + month + '-'
            } else {
              result += month + '-'
            }

            if (day < 10) {
              result += '0' + day
            } else {
              result += day
            }
          }
        }
      }

      return result
    } catch (e) {
      return result
    }
  }

  getNextStrData (dataStr) {
    if (this.isNotEmpty(dataStr)) {
      const dd = new Date(dataStr)
      dd.setDate(dd.getDate() + 1)
      const y = dd.getFullYear()
      const m = dd.getMonth() + 1
      const d = dd.getDate()
      return y + '-' + m + '-' + d
    }
  }

  formatDateTime (timestamp) {
    if (typeof timestamp === 'string') {
      timestamp = parseInt(timestamp, 10)
    }

    if (this.isNotEmpty(timestamp)) {
      const timeZone = this.isSummerTime(timestamp)
      const offset = (new Date(timestamp).getTimezoneOffset() / 60 + timeZone) * 3600 * 1000
      if (typeof offset === 'number') {
        timestamp += offset
      }
      return new Date(timestamp).format('yyyy-MM-dd HH:mm:ss')
    } else {
      return '-- ::'
    }
  }

  isSummerTime (timeStamp) {
    const time = new Date(timeStamp)
    const year = time.getUTCFullYear()

    const start = new Date(year, 2, 1).getDay()
    const end = new Date(year, 10, 1).getDay()
    const startMonthday = 15 - start
    const endMonthday = 8 - end
    const offset = 12 * 3600 * 1000
    if (new Date(year, 2, startMonthday).getTime() - offset < timeStamp && new Date(year, 10, endMonthday).getTime() - offset > timeStamp) {
      return -4
    } else {
      return -5
    }
  }

  formatTimeString (value) {
    const timeZone = this.isSummerTime(value)
    const offset = (new Date(value).getTimezoneOffset() / 60 + timeZone) * 3600 * 1000
    if (typeof offset === 'number') {
      value += offset
    }
    return new Date(parseInt(value)).format('HH:mm:ss')
  }

  formatOperatedBy (operatedBy) {
    let result = ''
    if (this.isNotEmpty(operatedBy)) {
      try {
        operatedBy = JSON.parse(operatedBy)
        if (this.isEmpty(operatedBy.firstName) && this.isEmpty(operatedBy.middleName) && this.isEmpty(operatedBy.lastName)) {
          result = operatedBy
        } else {
          const firstName = operatedBy.firstName
          const middleName = operatedBy.middleName
          const lastName = operatedBy.lastName
          result += this.isEmpty(firstName) ? '' : firstName
          result += this.isEmpty(middleName) ? '' : (' ' + firstName)
          result += this.isEmpty(lastName) ? '' : (' ' + lastName)
        }
      } catch (e) {
        result = operatedBy
      }
    }
    return result
  }

  formatPhone (phone) {
    if (this.isNotEmpty(phone)) {
      try {
        phone = phone.toString().replace(/[^0-9]/gi, '')
        return '(' + phone.substring(0, 3) + ')' + phone.substring(3, 6) + '-' + phone.substring(6, phone.length)
      } catch (e) {
        return null
      }
    } else {
      return null
    }
  }

  formatSsn (ssn) {
    if (this.isNotEmpty(ssn)) {
      try {
        ssn = ssn.toString().replace(/[^0-9]/gi, '')
        return ssn.substring(0, 3) + '-' + ssn.substring(3, 5) + '-' + ssn.substring(5, ssn.length)
      } catch (e) {
        return null
      }
    } else {
      return null
    }
  }

  formatPercent (num, digits) {
    let result = 'N/A'
    try {
      const floatNum = parseFloat(num)
      if (this.isEmpty(digits)) {
        digits = 2
      }

      const bigDecimalNum = new BigDecimal(floatNum)
      const hundred = new BigDecimal(100)
      const bigDecimalHundredNum = bigDecimalNum.multiply(hundred)

      result = bigDecimalHundredNum.round(digits, BigDecimal.RoundingModes.HALF_UP).getValue()
      return result + '%'
    } catch (e) {
      return result
    }
  }

  properCase (value) {
    let separator
    if (value.includes(', ')) separator = ', '
    else separator = ' '

    const array = value.toUpperCase().split(separator)
    const newArray = []

    for (let i = 0; i < array.length; i++) {
      if (array[i].includes(' ')) {
        newArray.push(this.properCaseForSpace(array[i]))
      } else {
        if (array[i].length <= 2) {
          newArray.push(array[i])
        } else {
          if (array[i].includes('/')) newArray.push(array[i])
          else newArray.push(array[i][0] + array[i].substr(1).toLowerCase())
        }
      }
    }

    return newArray.join(separator)
  }

  transferBlackFieldKey (key) {
    let result = null
    switch (key) {
      case 'EMAIL':
        result = 'email'
        break
      case 'SSN':
        result = 'ssn'
        break
      case 'STATE':
        result = 'state'
        break
      case 'ACCOUNTNUMBER':
        result = 'accountnumber'
        break
      case 'ROUTINGNUMBER':
        result = 'routingnumber'
        break
      case 'ZIP':
        result = 'zip'
        break
      case 'BIRTHDAY':
        result = 'birthday'
        break
      case 'LASTPAYDAY':
        result = 'lastPayday'
        break
    }
    return result
  }

  properCaseForSpace (value) {
    const separator = ' '
    const array = value.toUpperCase().split(separator)
    const newArray = []
    for (let i = 0; i < array.length; i++) {
      if (this.isNotEmpty(array[i]) && this.isNotEmpty(array[i].toString().replace(' ', ''))) {
        if (array[i].includes('/')) newArray.push(array[i])
        else newArray.push(array[i][0] + array[i].substr(1).toLowerCase())
      }
    }
    return newArray.join(separator)
  }

  compareArr (key) {
    return function (value1, value2) {
      const val1 = value1[key]
      const val2 = value2[key]
      return val1 - val2
    }
  }

  array2json (array, fieldKey, valueKey) {
    const result = {}
    if (this.isNotEmpty(array)) {
      for (let i = 0; i < array.length; i++) {
        const dataJson = array[i]
        if (Object.prototype.hasOwnProperty.call(dataJson, fieldKey)) {
          const key = dataJson[fieldKey]
          let value = null
          if (Object.prototype.hasOwnProperty.call(dataJson, valueKey)) {
            value = dataJson[valueKey]
          }
          result[key] = value
        }
      }
    }
    return result
  }

  getRandomKey (index) {
    return index + Math.random()
  }

  collectionFieldRender (feeList, template, format, type) {
    let result = 'N/A'
    for (const k of feeList) {
      if (k.type === type) {
        if (template === 'amount') {
          result = k.amount
        }
        if (template === 'unpaidFee') {
          result = k.unpaidFee
        }
        if (template === 'nsfFee') {
          result = k.nsfFee
        }
        if (template === 'lateFee') {
          result = k.lateFee
        }
        if (template === 'interest') {
          result = k.interest
        }
        if (template === 'principal') {
          result = k.principal
        }
        if (template === 'overflow') {
          result = k.overflow
        }
      }
    }
    result = this.formatCurrency(Number(result))
    return result
  }

  fieldRender (data, template, format, options, properCase, field, operator, currentLockedId, privilegeCode, privileges) {
    let result = 'N/A'

    let fieldKey
    if (this.isNotEmpty(data)) {
      const placeholders = template.fetchPlaceholder()
      if (placeholders instanceof Array) {
        for (const placeholder of placeholders) {
          fieldKey = placeholder.substring(1, placeholder.length - 1)
          let fieldValue = data[fieldKey]
          if (fieldKey === 'language' && fieldValue === undefined) {
            fieldValue = 101 // Default to English if 'language' is null
          }
          if (this.isEmpty(fieldValue)) {
            delete data[fieldKey]
            continue
          }

          if (this.isNotEmpty(options)) {
            const optionData = this.getOptionDataInFieldRender(options, fieldKey, data)

            if (optionData) {
              let optionText
              if (fieldKey === 'loanStatus') {
                // for pps loan history
                optionText = this.getLoanStatus(fieldValue)
              } else {
                optionText = this.getEnumTextByValue(optionData, fieldValue)
              }
              template = template.replace(placeholder, optionText)
            }
          }
        }
      }

      let source
      if (Object.keys(data).length !== 0) {
        source = template.format(data)
      } else {
        source = data
      }
      result = this.getTargetInFieldRender(source, format, properCase)
    }

    if (this.isNotEmpty(fieldKey) && this.isNotEmpty(field) && this.isNotEmpty(field.isHidePll) && this.isNotEmpty(operator)) {
      const operatorId = operator.id
      const privilege = this.getPrivilegeValueByCode(privileges, privilegeCode)
      if (((privilege & DataType.PrivilegeType.READABLE) !== DataType.PrivilegeType.READABLE) &&
        (currentLockedId === -1 || currentLockedId !== operatorId)) {
        result = this.maskSensitiveCharacter(fieldKey, result)
      }
    }
    return result
  }

  getPrivilegeValueByCode (privileges, privilegeCode) {
    let result = 0

    if (this.isNotEmpty(privileges)) {
      for (const item of privileges) {
        if (item.code === privilegeCode) {
          result = item.privilege
          break
        }
      }
    }

    return result
  }

  getOptionDataInFieldRender (options, fieldKey, data) {
    let optionData = options[fieldKey]

    if (fieldKey === 'firstDayOfMonth' || fieldKey === 'secondDayOfMonth') {
      const payrollFrequency = data.payrollFrequency
      if (payrollFrequency === DataType.PayrollFrequencyEnum.SEMI_MONTHLY.value) {
        optionData = DataType.DayOfSemiMonth
      } else if (payrollFrequency === DataType.PayrollFrequencyEnum.MONTHLY.value) {
        optionData = DataType.DayOfMonth
      }
    }

    if (fieldKey === 'program') {
      optionData = options
    }
    return optionData
  }

  getTargetInFieldRender (source, format, properCase) {
    let target = 'N/A'
    if (this.isNotEmpty(source)) {
      switch (format) {
        case 'currency':
          target = this.formatCurrency(source)
          break
        case 'date':
          target = this.formatDate(source)
          break
        case 'dateWithZero':
          target = this.formatDateWithZero(source)
          break
        case 'datetime':
          target = this.formatDateTime(source)
          break
        case 'phone':
          target = this.formatPhone(source)
          break
        case 'ssn':
          target = this.formatSsn(source)
          break
        case 'percent':
          target = this.formatPercent(source)
          break
        default:
          target = source
          break
      }
    }

    if (this.isNotEmpty(properCase)) {
      target = this.properCase(target)
    }
    target = target && target.trim()
    if (target === 'Underwriter Review') {
      target = 'Application Review'
    }
    return target
  }

  renderOptIn (optInData, optInRes) {
    const array = optInData
    if (this.isNotEmpty(optInRes)) {
      for (const optIn of optInRes) {
        for (const item of array) {
          if (optIn.type === item.optInType) {
            const value = optIn.value
            item.status.doNotCall = (value & 2) === 2
            item.status.uncontactable = (value & 4) === 4
            item.status.isMarketing = (value & 8) === 8
            item.status.isOperation = (value & 16) === 16
          }
        }
      }
    }
    return array
  }

  controlOptInSwitch (optInData, optInType, value) {
    for (const index in optInData) {
      if (optInData[index].optInType === optInType) {
        if ((value & 2) === 2 || (value & 4) === 4) {
          optInData[index].status.isMarketing = false
          optInData[index].status.isOperation = false
        } else if ((value & 8) === 8 || (value & 16) === 16) {
          optInData[index].status.doNotCall = false
          optInData[index].status.uncontactable = false
        }
      }
    }
    return optInData
  }

  getOptInValue (optInDataArray) {
    const jsonOptIn = []

    for (const optInData of optInDataArray) {
      let optInValue = 0
      optInData.status.doNotCall === true ? (optInValue += 2) : (optInValue += 0)
      optInData.status.uncontactable === true ? (optInValue += 4) : (optInValue += 0)
      optInData.status.isMarketing === true ? (optInValue += 8) : (optInValue += 0)
      optInData.status.isOperation === true ? (optInValue += 16) : (optInValue += 0)

      jsonOptIn.push({ type: optInData.optInType, value: optInValue })
    }
    return jsonOptIn
  }

  getOperatedActionByEventLog (eventLog, roleList, account) {
    let operatedAction = 'N/A'

    if (this.isEmpty(eventLog)) {
      return operatedAction
    }

    const roleCode = eventLog.roleCode
    if (this.isNotEmpty(roleCode)) {
      return roleCode + '_ACTION'
    }

    const operatedId = eventLog.operatedId
    if (this.isEmpty(operatedId)) {
      return DataType.OperatorIdConst.SYSTEM_ACTION.text
    }
    if (operatedId < 0) {
      return this.getEnumTextByValue(DataType.OperatorIdConst, operatedId)
    }

    const myRoleId = this.isNotEmpty(account) ? account.roleId : ''
    let roleId = ''
    let operatedBy = eventLog.operatedBy
    if (this.isNotEmpty(operatedBy)) {
      if (typeof operatedBy === 'string') {
        try {
          operatedBy = JSON.parse(operatedBy)
        } catch (e) {}
      }
      roleId = operatedBy.roleId
    }

    if (this.isNotEmpty(roleId) && this.isNotEmpty(myRoleId)) {
      if (roleId === myRoleId) {
        return this.getOperatedNameByEventLog(eventLog)
      }

      for (const item of roleList) {
        if (roleId === item.id) {
          operatedAction = item.code + '_ACTION'
        }
      }
    }

    if (this.isEmpty(operatedAction)) {
      operatedAction = DataType.OperatorIdConst.SYSTEM_ACTION.text
    }

    return operatedAction
  }

  formatRoleCode (operatedAction) {
    let result = ''
    if (this.isEmpty(operatedAction)) {
      return result
    }

    if (!operatedAction.includes('ACTION')) {
      return operatedAction
    }

    const keyArray = operatedAction.toString().toUpperCase()
      .replace(/_/g, ' ')
      .split(' ')
    for (let i = 0; i < keyArray.length - 1; i++) {
      result += keyArray[i].slice(0, 1).toUpperCase()
    }

    switch (operatedAction) {
      case 'ADMINISTRATOR_ACTION':
        result = 'AN'
        break
      case 'COLLECTION_AGENT_ACTION':
        result = 'LA'
        break
      case 'COLLECTION_SUPERVISOR_ACTION':
        result = 'LS'
        break
      case 'COLLECTION_MANAGER_ACTION':
        result = 'LM'
        break
      case 'RETENTION_AGENT_ACTION':
        result = 'EA'
        break
      case 'RETENTION_SUPERVISOR_ACTION':
        result = 'ES'
        break
      case 'RESOLUTIONS_AGENT_ACTION':
        result = 'IA'
        break
      case 'RESOLUTIONS_SUPERVISOR_ACTION':
        result = 'IS'
        break
    }

    return result
  }

  formatOperatedByInTableView (isShowOperatedBy, operatedBy, roleList, account) {
    if (isShowOperatedBy) {
      return this.getFullName(operatedBy)
    } else {
      return this.formatOperatedAction(this.getOperatedActionByOperatedBy(operatedBy, roleList, account))
    }
  }

  formatOperatedAction (operatedAction) {
    let result = ''
    if (this.isEmpty(operatedAction)) {
      return result
    }
    const keyArray = operatedAction.toString().toLowerCase()
      .replace(/_/g, ' ')
      .split(' ')
    for (const item of keyArray) {
      result += item.slice(0, 1).toUpperCase() + item.slice(1) + ' '
    }
    result = result.trim()
    return result
  }

  getOperatedActionByOperatedBy (operatedBy, roleList, account) {
    let operatedAction = 'N/A'

    if (this.isEmpty(operatedBy)) {
      return operatedAction
    }

    const myRoleId = this.isNotEmpty(account) ? account.roleId : ''
    let roleId = ''
    if (this.isNotEmpty(operatedBy)) {
      if (typeof operatedBy === 'string') {
        try {
          operatedBy = JSON.parse(operatedBy)
        } catch (e) {}
      }
      roleId = operatedBy.roleId
    }

    if (this.isNotEmpty(roleId) && this.isNotEmpty(myRoleId)) {
      if (roleId === myRoleId) {
        return this.getFullName(operatedBy)
      }

      for (const item of roleList) {
        if (roleId === item.id) {
          operatedAction = item.code + '_ACTION'
        }
      }
    }

    if (this.isEmpty(operatedAction)) {
      operatedAction = DataType.OperatorIdConst.SYSTEM_ACTION.text
    }

    return operatedAction
  }

  getOperatedNameByEventLog (eventLog) {
    let operatedName = 'N/A'

    if (this.isEmpty(eventLog)) {
      return operatedName
    }

    let operatedId = eventLog.operatedId
    if (this.isEmpty(operatedId)) {
      operatedId = DataType.OperatorIdConst.SYSTEM_ACTION.value
    }
    if (operatedId < 0) {
      operatedName = this.getEnumTextByValue(DataType.OperatorIdConst, operatedId)
    } else {
      let operatedBy = eventLog.operatedBy
      if (this.isNotEmpty(operatedBy)) {
        if (typeof operatedBy === 'string') {
          try {
            operatedBy = JSON.parse(operatedBy)
          } catch (e) {
            operatedName = operatedBy
          }
        }
        if (this.isNotEmpty(operatedBy)) {
          if (Object.prototype.hasOwnProperty.call(operatedBy, 'firstName')) {
            operatedName = operatedBy.firstName
          }

          if (Object.prototype.hasOwnProperty.call(operatedBy, 'middleName')) {
            operatedName = operatedName + ' ' + operatedBy.middleName
          }

          if (Object.prototype.hasOwnProperty.call(operatedBy, 'lastName')) {
            operatedName = operatedName + ' ' + operatedBy.lastName
          }
        }
      }
    }

    return operatedName
  }

  getLoanStatus (sourceValue) {
    let result = 'N/A'
    for (const item in DataType.LoanStatus) {
      if (DataType.LoanStatus[item].value === sourceValue) {
        result = DataType.LoanStatus[item].text
        if (result === 'Underwriter Review') {
          result = 'Application Review'
        }
      }
    }
    return result
  }

  isEmployeeKey (key) {
    return [
      DataType.JsonKeyConst.FOLLOWUP_BY,
      DataType.JsonKeyConst.OPERATOR_DATA,
      DataType.JsonKeyConst.OWNER_DATA,
      DataType.JsonKeyConst.SEND_BACK_BY,
      DataType.JsonKeyConst.APPROVED_BY
    ].includes(key)
  }

  isCurrencyKey (key) {
    return [
      DataType.JsonKeyConst.PRINCIPAL,
      DataType.JsonKeyConst.INTEREST,
      DataType.JsonKeyConst.NSF_FEE,
      DataType.JsonKeyConst.LATE_FEE,
      DataType.JsonKeyConst.APPROVED_AMOUNT,
      DataType.JsonKeyConst.LOAN_SIZE_AMOUNT,
      DataType.JsonKeyConst.AMOUNT_OF_OPEN_LOANS,
      DataType.JsonKeyConst.BANK_ACCOUNT_BALANCE,
      DataType.JsonKeyConst.TOTAL_WAIVED_AMOUNT,
      DataType.JsonKeyConst.TOTAL_WAIVED_LATE_FEE,
      DataType.JsonKeyConst.TOTAL_WAIVED_NSF_FEE,
      DataType.JsonKeyConst.TOTAL_WAIVED_PRINCIPAL,
      DataType.JsonKeyConst.TOTAL_WAIVED_INTEREST,
      DataType.JsonKeyConst.MONTHLY_INCOME,
      DataType.JsonKeyConst.LOAN_AMOUNT,
      DataType.JsonKeyConst.TOTAL_AMOUNT,
      DataType.JsonKeyConst.ACCOUNT_BALANCE,
      DataType.JsonKeyConst.REGULAR_AMOUNT,
      DataType.JsonKeyConst.AMOUNT,
      DataType.JsonKeyConst.BANK_FEE,
      DataType.JsonKeyConst.UNPAID_FEE,
      DataType.JsonKeyConst.ADDITIONAL_FEE,
      DataType.JsonKeyConst.REQUESTED_AMOUNT
    ].includes(key)
  }

  isIBVCode (key) {
    return [
      DataType.JsonKeyConst.REQUEST_CODE,
      DataType.JsonKeyConst.CONTACT_TYPE
    ].includes(key)
  }

  isDateKey (key) {
    return [
      DataType.JsonKeyConst.EFFECTIVE_DATE,
      DataType.JsonKeyConst.CREDIT_DATE,
      DataType.JsonKeyConst.LAST_PAYDAY,
      DataType.JsonKeyConst.TRANSACTION_DATE,
      DataType.JsonKeyConst.CONTACT_START_TIME,
      DataType.JsonKeyConst.CONTACT_STOP_TIME,
      DataType.JsonKeyConst.SHIFT_START_TIME,
      DataType.JsonKeyConst.SHIFT_STOP_TIME,
      DataType.JsonKeyConst.LOCKED_AT,
      DataType.JsonKeyConst.CREATE_FILE_DATE,
      DataType.JsonKeyConst.INSTALLMENT_DATE,
      DataType.JsonKeyConst.DUE_DATE,
      DataType.JsonKeyConst.LAST_DEBIT_DATE,
      DataType.JsonKeyConst.FIRST_CREDIT_DATE,
      DataType.JsonKeyConst.FIRST_DEBIT_DATE
    ].includes(key)
  }

  isDateTimeKey (key) {
    return [
      DataType.JsonKeyConst.FOLLOW_UP_AT,
      DataType.JsonKeyConst.SENT_AT,
      DataType.JsonKeyConst.SIGNED_AT,
      DataType.JsonKeyConst.UPDATED_AT,
      DataType.JsonKeyConst.CREATED_AT,
      DataType.JsonKeyConst.SEND_EMAIL_DATE
    ].includes(key)
  }

  isIntervalKey (key) {
    return [DataType.JsonKeyConst.SSN].includes(key)
  }

  toIntervalString (value) {
    try {
      value = value.toString()
      if (value.indexOf('-') === -1) {
        value = value.substring(0, 3) + '-' + value.substring(3, 5) + '-' + value.substring(5, value.length)
      }
      return value
    } catch (e) {
      return ''
    }
  }

  maskSensitiveCharacter (key, value) {
    let result = 'N/A'

    try {
      value = value.toString()
      if (value.length > 4 && this.isNotEmpty(key) && this.isNotEmpty(value)) {
        if (DataType.JsonKeyConst.SSN === key && value.indexOf('-') === -1) {
          result = value.substring(0, 3).replace(/[0-9]/ig, '*') + '-' + value.substring(3, 5).replace(/[0-9]/ig, '*') + '-' + value.substring(5, value.length)
        } else if (key.indexOf('Phone') !== -1) {
          value = value.trim().replace(/[^0-9]/ig, '')
          result = '(' + value.substring(0, 3).replace(/[0-9]/ig, '*') + ') ' + value.substring(3, 6).replace(/[0-9]/ig, '*') + '-' + value.substring(6, value.length)
        } else if (key.includes('CardNumber')) {
          result = value.substring(0, value.length - 4).replace(/[0-9]/ig, '*') + value.substring(value.length - 4, value.length)
        } else {
          result = value.substring(0, 5).replace(/[0-9]/ig, '*') + value.substring(5, value.length)
        }
      }
    } catch (e) {
      result = 'N/A'
    }

    return result
  }

  spliceFullName (firstName, middleName, lastName) {
    let fullName = ''
    if (this.isNotEmpty(firstName)) {
      fullName += firstName
    }
    if (this.isNotEmpty(middleName)) {
      fullName += ' ' + middleName
    }
    if (this.isNotEmpty(lastName)) {
      fullName += ' ' + lastName
    }
    return fullName
  }

  isPhoneOrFaxKey (key) {
    return [
      DataType.JsonKeyConst.HOME_PHONE,
      DataType.JsonKeyConst.CELL_PHONE,
      DataType.JsonKeyConst.EMPLOYER_PHONE,
      DataType.JsonKeyConst.BANK_PHONE
    ].includes(key)
  }

  removeKey (arr, key) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === key) {
        arr.splice(i, 1)
      }
    }
  }

  isToPercent (key) {
    return [
      DataType.JsonKeyConst.INTEREST_RATE,
      DataType.JsonKeyConst.APR
    ].includes(key)
  }

  isToMask (key) {
    return [
      DataType.JsonKeyConst.SSN,
      DataType.JsonKeyConst.ACCOUNT_NO,
      DataType.JsonKeyConst.CELL_PHONE
    ].includes(key)
  }

  // 下划线转换驼峰
  toHump (name) {
    try {
      return name.replace(/_(\w)/g, function (all, letter) {
        return letter.toUpperCase()
      })
    } catch (e) {
      return ''
    }
  }

  // 驼峰转换下划线
  toLine (name) {
    try {
      return name.replace(/([A-Z])/g, '_$1').toLowerCase()
    } catch (e) {
      return ''
    }
  }

  getFraudFlag (value) {
    if (parseInt(value) === 1) {
      return DataType.FraudFlag.SUSPECTED.text
    } else if (parseInt(value) === 2) {
      return DataType.FraudFlag.MISMATCHED_IBV.text
    } else {
      return DataType.FraudFlag.RELEASED.text
    }
  }

  adapterKey (key, loanType) {
    let result = ''
    if (this.isNotEmpty(key)) {
      const keyArray = key.toString()
        .replace(/[A-Z]/g, function (letter) {
          return ' ' + letter
        })
        .split(' ')
      for (const item of keyArray) {
        result += item.slice(0, 1).toUpperCase() + item.slice(1) + ' '
      }
      result = result.trim()

      switch (key) {
        case DataType.JsonKeyConst.CHANGE_TYPE:
          return 'Function Name'
        case DataType.JsonKeyConst.LAST_PAYDAY:
          return 'Last Payroll Date'
        case DataType.JsonKeyConst.TRANSACTION_MODE:
          return 'Payment Mode'
        case DataType.JsonKeyConst.TRANSACTION_DATE:
          return 'Payment Date'
        case DataType.JsonKeyConst.BANK_ACCOUNT_BALANCE:
          return 'Account Balance'
        case DataType.JsonKeyConst.DOCUMENT_URL:
          return 'Document'
        case DataType.JsonKeyConst.CERTIFICATE_URL:
          return 'Certificate'
        case DataType.JsonKeyConst.LOAN_AGREEMENT_URL:
          return 'Loan Agreement'
        case DataType.JsonKeyConst.CONTACT_START_TIME:
          return 'Contact Client Start Time'
        case DataType.JsonKeyConst.CONTACT_STOP_TIME:
          return 'Contact Client Finish Time'
        case DataType.JsonKeyConst.SHIFT_START_TIME:
          return 'Work Shift Start Time'
        case DataType.JsonKeyConst.SHIFT_STOP_TIME:
          return 'Work Shift Stop Time'
        case DataType.JsonKeyConst.WITHDRAW_CODE:
          return 'Withdraw Reason'
        case DataType.JsonKeyConst.CATEGORY:
          return 'Customer Type'
        case DataType.JsonKeyConst.VOE:
          return 'VOE'
      }

      if (this.isNotEmpty(loanType) && loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
        switch (key) {
          case DataType.JsonKeyConst.EFFECTIVE_DATE:
            return 'Initial Disbursement Date'
          case DataType.JsonKeyConst.APPROVED_AMOUNT:
            return 'Initial Advance'
          case DataType.JsonKeyConst.LOAN_AMOUNT:
            return 'Amount Financed'
          case 'effectiveDateVerify':
            return 'Initial Disbursement Date Verify'
        }
      }
    }
    return result
  }

  // eslint-disable-next-line complexity
  adapterValue (key, value) {
    if (this.isEmpty(value)) {
      return 'N/A'
    } else if (this.isCurrencyKey(key)) {
      return this.formatCurrency(value)
    } else if (this.isDateKey(key)) {
      return this.formatDate(value)
    } else if (this.isDateTimeKey(key)) {
      return this.formatDateTime(value)
    } else if (this.isToMask(key)) {
      return this.maskSensitiveCharacter(key, value)
    } else if (this.isIntervalKey(key)) {
      return this.toIntervalString(value)
    } else if (this.isPhoneOrFaxKey(key)) {
      return this.formatPhone(value)
    } else if (this.isToPercent(key)) {
      return this.formatPercent(value)
    } else if (this.isEmployeeKey(key)) {
      return value.fullName
    } else if (this.isIBVCode(key)) {
      return this.IBVData(key, value)
    } else if (this.isNotEmpty(key) && key.toString().indexOf('Verify') >= 0) {
      return this.getEnumTextByValue(DataType.ReviewStatusEnum, value)
    } else {
      switch (key) {
        case DataType.JsonKeyConst.CORRECTION_CODE:
          return this.getEnumTextByValue(DataType.LoanCorrectionReasonEnum, value)
        case DataType.JsonKeyConst.IBV_STATUS:
          return this.getEnumTextByValue(DataType.IbvStatus, value)
        case DataType.JsonKeyConst.CHANGE_TYPE:
          return this.getEnumTextByValue(DataType.ChangeTypeEnum, value)
        case DataType.JsonKeyConst.PAYROLL_FREQUENCY:
          return this.getEnumTextByValue(DataType.PayrollFrequency, value)
        case DataType.JsonKeyConst.TRANSACTION_MODE:
          return this.getEnumTextByValue(DataType.TransactionModeEnum, value)
        case DataType.JsonKeyConst.ACCOUNT_TYPE:
          return this.getEnumTextByValue(DataType.BankAccountType, value)
        case DataType.JsonKeyConst.SIGN_STATUS:
        case DataType.JsonKeyConst.SIGNATURE_STATUS:
          return this.getEnumTextByValue(DataType.SignStatus, value)
        case DataType.JsonKeyConst.PAYDAY_ON_HOLIDAY:
          return this.getEnumTextByValue(DataType.PaydayOnHolidayType, value)
        case DataType.JsonKeyConst.FIRST_DAY_OF_WEEK:
          return this.getEnumTextByValue(DataType.FirstDayOfWeek, value)
        case DataType.JsonKeyConst.STATUS:
        case DataType.JsonKeyConst.LOAN_STATUS:
        case DataType.JsonKeyConst.APPLICATION_STATUS:
          return this.getLoanStatus(value)
        case DataType.JsonKeyConst.SLAVE_LOAN_STATUS:
          return this.getLoanStatus(value)
        case DataType.JsonKeyConst.TRANSACTION_STATUS:
          return this.getEnumTextByValue(DataType.TransactionStatusEnum, value)
        case DataType.JsonKeyConst.GENDER:
          return this.getEnumTextByValue(DataType.Gender, value)
        case DataType.JsonKeyConst.PAYROLL_TYPE:
          return this.getEnumTextByValue(DataType.PayrollTypeEnum, value)
        case DataType.JsonKeyConst.MILITARY:
          return this.getEnumTextByValue(DataType.BooleanInBinary, value)
        case DataType.JsonKeyConst.WITHDRAW_CODE:
          return this.getEnumTextByValue(DataType.WithdrawCodeEnum, value)
        case DataType.JsonKeyConst.DOCUMENT_TYPE:
          return this.getEnumTextByValue(DataType.DocumentTypeEnum, value)
        case DataType.JsonKeyConst.PAYDAY_ON_AVAILABLE:
          return this.getEnumTextByValue(DataType.PaydayOnAvailableEnum, value)
        case DataType.JsonKeyConst.VOE:
        case DataType.JsonKeyConst.VALIDATION_OF_EMPLOYMENT:
          return this.getEnumTextByValue(DataType.VoE, value)
        case DataType.JsonKeyConst.CATEGORY:
          return this.getEnumTextByValue(DataType.CategoryEnum, value)
        case DataType.JsonKeyConst.LOCK_REASON:
          return this.getEnumTextByValue(DataType.LockLoanReasonEnum, value)
        case DataType.JsonKeyConst.UNLOCK_REASON:
          return this.getEnumTextByValue(DataType.UnlockLoanReasonEnum, value)
        case DataType.JsonKeyConst.MILITARY_LENDING_ATC:
          return this.getEnumTextByValue(DataType.MilitaryEnum, value)
        case DataType.JsonKeyConst.FIRST_DAY_OF_MONTH:
          return this.getEnumTextByValue(DataType.TotalDayOfMonthEnum, value)
        case DataType.JsonKeyConst.SECOND_DAY_OF_MONTH:
          return this.getEnumTextByValue(DataType.TotalDayOfMonthEnum, value)
        case DataType.JsonKeyConst.JOB_TYPE:
          return this.getEnumTextByValue(DataType.JobType, value)
        case DataType.JsonKeyConst.PAYMENT_MODE:
        case DataType.JsonKeyConst.DEFAULT_REPAYMENT_MODE:
        case DataType.JsonKeyConst.DEFAULT_DISBURSEMENT_MODE:
          return this.getEnumTextByValue(DataType.TransactionModeEnum, value)
        case DataType.JsonKeyConst.LANGUAGE:
          return this.getEnumTextByValue(DataType.Language, value)
        case DataType.JsonKeyConst.AUTHORIZATION_TYPE:
          return this.getEnumTextByValue(DataType.AuthorizationTypeEnum, parseInt(value))
        case DataType.JsonKeyConst.FROZEN:
          return this.getEnumTextByValue(DataType.FrozenStatusEnum, value)
        case DataType.JsonKeyConst.TRANSACTION_TYPE:
          return this.getEnumTextByValue(DataType.TransactionTypeOptions, value)
        case DataType.JsonKeyConst.REMOTE_CONSENT_FLAG:
          return value === 1 ? 'Yes' : 'No'
        case DataType.JsonKeyConst.FRAUD_STATUS:
          return this.getFraudFlag(value)
        case DataType.JsonKeyConst.SIGNATURE_SOURCE:
          return this.getEnumTextByValue(DataType.SignatureSource, value)
        case DataType.JsonKeyConst.MARKETING_EMAIL:
          return this.getEnumTextByValue(DataType.MarketingEmail, value)
        case DataType.JsonKeyConst.SYSTEM_VERIFICATION:
          return 'SystemVerification： ' + this.getEnumTextByValue(DataType.SystemVerificationResult, value)
        case DataType.JsonKeyConst.AGENT_VERIFICATION:
          return 'AgentVerification： ' + this.getEnumTextByValue(DataType.AgentVerificationResult, value)
        case DataType.JsonKeyConst.ILV_STATE:
          return this.getEnumTextByValue(DataType.LitigantTypeEnum, value)
        case DataType.JsonKeyConst.PROVIDER:
          return this.getEnumTextByValue(DataType.IBVProviderType, value)
        default:
          return value
      }
    }
  }

  adapterValueForHtml (key, value) {
    let result = 'N/A'
    if (this.isNotEmpty(value)) {
      let adapterValue = this.adapterValue(key, value)
      if (this.isNotEmpty(adapterValue)) {
        adapterValue = adapterValue.toString()
        result = adapterValue.replace(/\\t/ig, '&nbsp;&nbsp;&nbsp;&nbsp;').replace(/\\n/ig, '<br/>').replace(/<br>/ig, '').replace(/\r\n/ig, '<br/>').replace(/\n/ig, '<br/>')
      }
    }

    return result
  }

  isJSON (str) {
    let result = false
    if (this.isNotEmpty(str)) {
      if (typeof str === 'string') {
        try {
          const obj = JSON.parse(str)
          result = typeof obj === 'object' && obj
        } catch (e) {}
      }
    }
    return result
  }

  displayByPayrollFrequency (fieldKey, payrollFrequency) {
    if (fieldKey === 'firstDayOfWeek' &&
      (payrollFrequency === DataType.PayrollFrequencyEnum.WEEKLY.value || payrollFrequency === DataType.PayrollFrequencyEnum.BI_WEEKLY.value)) {
      return true
    } else if (fieldKey === 'firstDayOfMonth' &&
      (payrollFrequency === DataType.PayrollFrequencyEnum.SEMI_MONTHLY.value || payrollFrequency === DataType.PayrollFrequencyEnum.MONTHLY.value)) {
      return true
    } else {
      return fieldKey === 'secondDayOfMonth' &&
        payrollFrequency === DataType.PayrollFrequencyEnum.SEMI_MONTHLY.value
    }
  }

  getSpeechCraftData (loan, languageCode) {
    const data = {}

    const customerData = {}
    const contractData = {}

    const gender = loan.gender
    if (gender === DataType.GenderEnum.MALE.value) {
      customerData.title = this.isEmpty(languageCode) || languageCode === 'GB' ? 'Mr.' : 'Sr.'
    } else if (gender === DataType.GenderEnum.FEMALE.value) {
      customerData.title = this.isEmpty(languageCode) || languageCode === 'GB' ? 'Mrs.' : 'Sra.'
    } else {
      customerData.title = 'Dear'
    }

    customerData.lastName = loan.lastName
    customerData.fullName = this.getFullName(loan)
    let accountNo = loan.accountNo
    if (this.isNotEmpty(accountNo)) {
      accountNo = accountNo.substr((accountNo.length) - 4, accountNo.length)
      customerData.accountNo = accountNo
    } else {
      customerData.accountNo = 'N/A'
    }
    const cardNo = loan.cardNo
    if (this.isNotEmpty(cardNo)) {
      customerData.cardNo = cardNo
    } else {
      customerData.cardNo = 'N/A'
    }

    contractData.apr = this.isEmpty(loan.apr) ? 'N/A' : this.formatPercent(loan.apr)
    contractData.payrollFrequency = this.isEmpty(loan.payrollFrequency) ? 'N/A' : this.getEnumTextByValue(DataType.PayrollFrequencyEnum, loan.payrollFrequency)
    contractData.portfolioId = loan.portfolioId
    contractData.interestRate = this.isEmpty(loan.interestRate) ? 'N/A' : this.formatPercent(loan.interestRate)
    contractData.debitCount = loan.debitCount || 'N/A'
    contractData.loanAmount = loan.loanAmount || 'N/A'
    contractData.paymentMode = this.isEmpty(loan.paymentMode) ? 'N/A' : this.getEnumTextByValue(DataType.TransactionModeEnum, loan.paymentMode)
    contractData.approvedAmount = this.formatCurrency(loan.approvedAmount) || 'N/A'
    contractData.transferredAmount = this.formatCurrency(loan.transferredAmount) || 'N/A'
    contractData.totalPrincipal = this.formatCurrency(loan.totalAmount) || 'N/A'
    contractData.regularAmount = this.isEmpty(loan.regularAmount) ? 'N/A' : this.formatCurrency(loan.regularAmount)
    contractData.totalAmount = this.isEmpty(loan.paymentProgress) || this.isEmpty(loan.paymentProgress.totalAmount) ? 'N/A' : this.formatCurrency(loan.paymentProgress.totalAmount)
    let firstDebitDate = loan.firstDebitDateText || 'N/A'
    if (this.isEmpty(firstDebitDate)) {
      firstDebitDate = loan.firstDebitDate || 'N/A'
    }
    contractData.firstDebitDate = firstDebitDate

    const account = store.getters.getAccount
    if (this.isNotEmpty(account)) {
      account.fullName = this.getFullName(account)
    }

    data.customer = customerData
    data.application = contractData
    data.portfolio = store.getters.getPortfolioJson
    data.currentDay = this.formatDate(new Date().getTime())
    data.account = account
    this.filterIrregularAmount(data)
    return data
  }

  getFullName (data) {
    if (this.isEmpty(data)) {
      return ''
    }
    try {
      if (typeof data === 'string') {
        data = JSON.parse(data)
      }
    } catch (e) {}
    let fullName = ''
    if (Object.prototype.hasOwnProperty.call(data, 'firstName') && this.isNotEmpty(data.firstName)) {
      data.firstName = data.firstName.toString().trim()
      if (this.isNotEmpty(data.firstName)) {
        fullName += data.firstName.toUpperCase().substr(0, 1) + data.firstName.substr(1)
      }
    }

    if (Object.prototype.hasOwnProperty.call(data, 'middleName') && this.isNotEmpty(data.middleName)) {
      data.middleName = data.middleName.toString().trim()
      if (this.isNotEmpty(data.middleName)) {
        fullName += ' ' + data.middleName.toUpperCase().substr(0, 1) + data.middleName.substr(1)
      }
    }

    if (Object.prototype.hasOwnProperty.call(data, 'lastName') && this.isNotEmpty(data.lastName)) {
      data.lastName = data.lastName.toString().trim()
      if (this.isNotEmpty(data.lastName)) {
        fullName += ' ' + data.lastName.toUpperCase().substr(0, 1) + data.lastName.substr(1)
      }
    }

    return fullName
  }

  filterIrregularAmount (data) {
    const regularAmount = data.application.regularAmount
    const irregularAmount = []
    for (const paymentScheduleItem of store.getters.getPaymentSchedule) {
      if (paymentScheduleItem.transactionType !== DataType.TransactionTypeEnum.CREDIT && this.formatCurrency(paymentScheduleItem.amount) !== regularAmount) {
        irregularAmount.push({
          date: paymentScheduleItem.transactionDate,
          amount: this.formatCurrency(paymentScheduleItem.amount)
        })
      }
    }
    data.application.irregularAmount = irregularAmount
  }

  whetherDoExpress (loanStatus) {
    return this.judgeStatus(loanStatus, 'withdraw') || this.judgeStatus(loanStatus, 'paidOff') || this.judgeStatus(loanStatus, 'lcsPaidOff') || this.judgeStatus(loanStatus, 'voided') || this.judgeStatus(loanStatus, 'InHouseSettlement') || this.judgeStatus(loanStatus, 'externalCollection')
  }

  judgeStatus (loanStatus, simpleStatus) {
    let result = false
    switch (simpleStatus) {
      case 'withdraw': {
        const withdrawStatus = [
          DataType.LoanStatus.NEGATIVE_WITHDRAWN.value,
          DataType.LoanStatus.POSITIVE_WITHDRAWN.value
        ]
        result = withdrawStatus.includes(loanStatus)
        break
      }
      case 'lcsPaidOff': {
        const lcsPaidOffStatus = [
          DataType.LoanStatus.IN_HOUSE_REPLAN_PAID_OFF.value,
          DataType.LoanStatus.IN_HOUSE_SETTLEMENT_PAID_OFF.value,
          DataType.LoanStatus.OUT_HOUSE_PAID_OFF.value,
          DataType.LoanStatus.OUT_HOUSE_CHARGE_OFF.value
        ]
        result = lcsPaidOffStatus.includes(loanStatus)
        break
      }
      case 'paidOff': {
        const paidOffStatus = [
          DataType.LoanStatus.PAID_OFF.value,
          DataType.LoanStatus.GOOD_STANDING_PAID_OFF.value,
          DataType.LoanStatus.WARNING_PAID_OFF.value,
          DataType.LoanStatus.TRANSFERRED_PAID_OFF.value
        ]
        result = paidOffStatus.includes(loanStatus)
        break
      }
      case 'voided': {
        const voidedStatus = [
          DataType.LoanStatus.VOIDED.value,
          DataType.LoanStatus.MANUALLY_VOIDED.value
        ]
        result = voidedStatus.includes(loanStatus)
        break
      }
      case 'goodStanding': {
        const goodStandingStatus = [
          DataType.LoanStatus.GOOD_STANDING.value,
          DataType.LoanStatus.GOOD_STANDING_PAID_OFF.value
        ]
        result = goodStandingStatus.includes(loanStatus)
        break
      }
      case 'new': {
        result = loanStatus === DataType.LoanStatus.NEW.value
        break
      }
      case 'InHouseSettlement': {
        const settlementStatus = [
          DataType.LoanStatus.IN_HOUSE_PAID_OFF_SETTLEMENT_QUEUE.value,
          DataType.LoanStatus.IN_HOUSE_PAID_OFF_SETTLEMENT.value
        ]
        result = settlementStatus.includes(loanStatus)
        break
      }
      case 'externalCollection': {
        const settlementStatus = [
          DataType.LoanStatus.OUT_HOUSE_SETTLEMENT_QUEUE.value
        ]
        result = settlementStatus.includes(loanStatus)
        break
      }
      default:
        break
    }
    return result
  }

  getSectionKeyByFeature (feature) {
    let result = ''
    switch (feature) {
      case SystemEnum.SECTION_FEATURE.PERSONAL:
        result = DataType.LoanSectionKey.PERSONAL
        break
      case SystemEnum.SECTION_FEATURE.EMPLOYMENT:
        result = DataType.LoanSectionKey.EMPLOYMENT
        break
      case SystemEnum.SECTION_FEATURE.BANK:
        result = DataType.LoanSectionKey.BANKING
        break
      case SystemEnum.SECTION_FEATURE.BANK_RECORDS:
        result = DataType.LoanSectionKey.STATEMENT
        break
      case SystemEnum.SECTION_FEATURE.LOAN_DETAILS:
        result = DataType.LoanSectionKey.PAYMENT_OPTION
        break
      default:
        break
    }
    return result
  }

  isWithdrawnStatus (loanStatus) {
    return DataType.LoanStatus.NEGATIVE_WITHDRAWN.value === loanStatus || DataType.LoanStatus.POSITIVE_WITHDRAWN.value === loanStatus
  }

  compareTwoPortfolioArray (newVal, oldVal) {
    let result = false
    const newValString = this.isNotEmpty(newVal) ? JSON.parse(JSON.stringify(newVal)).sort().toString() : ''
    const oldValString = this.isNotEmpty(oldVal) ? JSON.parse(JSON.stringify(oldVal)).sort().toString() : ''
    if (this.isNotEmpty(newVal) && (this.isEmpty(oldVal) || newValString !== oldValString)) {
      result = true
    }
    return result
  }

  convertVerticalPortfolio (portfolioId) {
    let pandaPortfolioId
    switch (portfolioId) {
      case 19000:
        pandaPortfolioId = 1
        break
      case 19001:
      case 19002:
      case 19003:
      case 19004:
      case 19005:
        break
      case 19006:
        pandaPortfolioId = 3
        break
      case 19007:
        pandaPortfolioId = 4
        break
    }
    return pandaPortfolioId
  }

  isShowSendEmailBtn (loan, routerPath) {
    return this.emailTemplateWithStatusAndRole(loan, routerPath).length > 0
  }

  emailTemplateWithStatusAndRole (loan, routerPath) {
    const result = []
    const loanType = loan.loanType
    const portfolioId = loan.portfolioId
    const roleCode = store.getters.getRoleCode
    const emailTemplateEnum = SystemEnum.EMAIL_TEMPLATE_ENUM
    let loanStatus = loan.loanStatus

    if (routerPath.includes(DataType.RouterPath.LOS_PATH) && !this.isWithdrawnStatus(loanStatus)) {
      result.push({ text: 'Loan Agreement', templateCode: ' ' })
    }

    if (loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value && !routerPath.includes(DataType.RouterPath.LOS_PATH)) {
      const slaveLoan = store.getters.getPPSLatestSlaveLoan
      if (this.isNotEmpty(slaveLoan)) {
        loanStatus = slaveLoan.loanStatus
      }

      if (this.isNotEmpty(slaveLoan) && slaveLoan.loanStatus === DataType.LoanStatus.PENDING_APPROVED.value) {
        result.push({ text: 'SUBSEQUENT ADVANCE DISCLOSURES', templateCode: 'CSL-2101' })
      }
    }
    for (const item in emailTemplateEnum) {
      const itemEnum = emailTemplateEnum[item]
      const statusArray = itemEnum.statusArray
      const roleArray = itemEnum.roleArray
      if (statusArray.includes(loanStatus) && (roleArray.includes(roleCode) || roleCode === DataType.RoleEnum.ADMINISTRATOR.code)) {
        if (itemEnum.pathCode === SystemEnum.EMAIL_TEMPLATE_ENUM.SUBSEQUENT_ADVANCES_EXPLANATION.pathCode) {
          if (loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
            result.push(itemEnum)
          }
        } else if (itemEnum.pathCode === SystemEnum.EMAIL_TEMPLATE_ENUM.VALLEY_SERVICING.pathCode) {
          if (portfolioId === 3 || portfolioId === 10) {
            result.push(itemEnum)
          }
        } else {
          result.push(itemEnum)
        }
      }
    }
    return result
  }

  arrayToObject (array) {
    const object = {}
    for (const element of JSON.parse(array)) {
      object[element.key] = element.value
    }
    return object
  }

  getQueryType (tabName) {
    let queryType
    switch (tabName) {
      case DataType.NotificationTab.WA_SUCCESSFULLY:
      case DataType.NotificationTab.WAI_SUCCESSFULLY:
        queryType = DataType.EmailQueryType.SENT_SUCCESSFULLY.value
        break
      case DataType.NotificationTab.WA_NEED_TO_SEND:
      case DataType.NotificationTab.WAI_NEED_TO_SEND:
        queryType = DataType.EmailQueryType.NOT_SENT_YET.value
        break
      case DataType.NotificationTab.WA_SENDING:
      case DataType.NotificationTab.WAI_SENDING:
        queryType = DataType.EmailQueryType.SENDING.value
        break
      default:
        break
    }
    return queryType
  }

  getCollectionProvider (tabName) {
    let collectionProvider
    switch (tabName) {
      case DataType.NotificationTab.WA_SUCCESSFULLY:
      case DataType.NotificationTab.WA_NEED_TO_SEND:
      case DataType.NotificationTab.WA_SENDING:
        collectionProvider = DataType.CollectionProviderEnum.WAGE_ASSIGNMENT.value
        break
      case DataType.NotificationTab.WAI_SUCCESSFULLY:
      case DataType.NotificationTab.WAI_NEED_TO_SEND:
      case DataType.NotificationTab.WAI_SENDING:
        collectionProvider = DataType.CollectionProviderEnum.WAGE_ASSIGNMENT_IN_HOUSE.value
        break
      default:
        break
    }
    return collectionProvider
  }
}

export { Tool }
